import { useDraftPrompt } from "../context/DraftPromptContext.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import API from "../config/api.js";

function SocialItem({
  platform,
  label,
  icon,
  profileImage,
  profileFallback,
  connected,
  connectUrl,
  checked,
  onChange,
  disabled,
}) {
  return (
    <div className={`col-md-12 ${platform}`}>
      <label className="border px-3 py-2 rounded-4 d-block">
        <div className="row g-0 align-items-center justify-content-between my-1">
          <div className="col-6 d-flex align-items-center">
            {profileImage && (
              <img
                src={profileImage}
                onError={(e) => (e.target.src = profileFallback)}
                alt=""
                className="rounded-circle shadow-sm position-relative"
                style={{
                  height: 20,
                  width: 20,
                  verticalAlign: "bottom",
                  marginRight: -10,
                }}
              />
            )}
            <img src={icon} style={{ height: 30, width: 30 }} alt={platform} />
            <span className="ms-2 fw-bold text-capitalize">{platform}</span>
          </div>

          <div className="col-6 text-end">
            {connected ? (
              <div className="form-check form-switch fs-4 d-inline-block float-end">
                <input
                  className="form-check-input mt-0"
                  type="checkbox"
                  role="switch"
                  checked={checked}
                  onChange={onChange}
                  disabled={disabled}
                />
              </div>
            ) : (
              <a
                className="btn btn-sm btn-outline-primary"
                href={connectUrl}
                style={{ padding: "7px 10px", fontSize: 10 }}
              >
                Connect
              </a>
            )}
          </div>
        </div>
      </label>
    </div>
  );
}

export default function DraftPromptSocials() {
  const { state, patch } = useDraftPrompt();
  const {
    userMetaFacebook,
    userMetaInstagram,
    userLinkedin,
    userTiktok,
    user,
  } = useAuth();

  const items = state.items || [];
  const hasVideo = items.some((i) => i.type === "reel" || i.type === "video");
  const hasMedia = items.some(
    (i) =>
      i.type === "image" ||
      i.type === "story" ||
      i.type === "reel" ||
      i.type === "video",
  );

  // Connected = object exists with its primary ID field (based on real API response)
  const fbConnected = !!userMetaFacebook?.idusermeta; // has idusermeta + facebookpagename
  const igConnected = !!userMetaInstagram?.idusermeta; // has idusermeta + instagramusername
  const liConnected = !!userLinkedin?.iduserlinkedin;
  const ttConnected = !!userTiktok?.idusertiktok;

  // Profile images
  const fbProfileImage = userMetaFacebook?.facebookpageimage || null;
  const igProfileImage = userMetaInstagram?.instagramprofilepicture || null;
  const liProfileImage = userLinkedin?.linkedinpageimage || null;
  const ttProfileImage = userTiktok?.tiktokuserimage || null;

  // Display names
  const fbName = userMetaFacebook?.facebookpagename || "Facebook";
  const igName = userMetaInstagram?.instagramusername || "Instagram";
  const liName = userLinkedin?.linkedinpagename || "LinkedIn";
  const ttName = userTiktok?.tiktokusername || "TikTok";

  const igDisabled = !hasMedia;
  const fbDisabled = false;
  const liDisabled = hasVideo && items.length > 1;

  const toggle = (key) => (e) => patch({ [key]: e.target.checked });

  return (
    <div>
      <label className="w-100 fw-bold mb-3">Select Social Networks</label>
      <div className="row g-2">
        <SocialItem
          platform="facebook"
          label={fbName}
          icon="/assets/img/facebook.png"
          profileImage={fbProfileImage}
          profileFallback="/assets/img/profile-facebook.png"
          connected={fbConnected}
          connectUrl={`${API.account}?connectFacebook`}
          checked={state.facebook && !fbDisabled}
          onChange={toggle("facebook")}
          disabled={fbDisabled}
        />

        <SocialItem
          platform="instagram"
          label={igName}
          icon="/assets/img/instagram.png"
          profileImage={igProfileImage}
          profileFallback="/assets/img/profile-instagram.png"
          connected={igConnected}
          connectUrl={`${API.account}?connectInstagram`}
          checked={state.instagram && !igDisabled}
          onChange={toggle("instagram")}
          disabled={igDisabled}
        />

        <SocialItem
          platform="linkedin"
          label={liName}
          icon="/assets/img/linkedin.png"
          profileImage={liProfileImage}
          profileFallback="/assets/img/profile-linkedin.png"
          connected={liConnected}
          connectUrl={`${API.account}?connectLinkedin`}
          checked={state.linkedin && !liDisabled}
          onChange={toggle("linkedin")}
          disabled={liDisabled}
        />

           <SocialItem
            platform="tiktok"
            label={ttName}
            icon="/assets/img/tiktok.png"
            profileImage={ttProfileImage}
            profileFallback="/assets/img/profile-tiktok.png"
            connected={ttConnected}
            connectUrl={`${API.account}?connectTiktok`}
            checked={state.tiktok}
            onChange={toggle("tiktok")}
            disabled={false}
          />
      </div>
    </div>
  );
}
